/**
 * @generated SignedSource<<7877b68dfeada65c35716abb7c2b749e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Calendar_enrollments$data = {
  readonly edges: ReadonlyArray<{
    readonly node: {
      readonly activityCountByDate: ReadonlyArray<{
        readonly count: number;
        readonly date: string | null | undefined;
      }> | null | undefined;
    } | null | undefined;
  } | null | undefined> | null | undefined;
  readonly " $fragmentType": "Calendar_enrollments";
};
export type Calendar_enrollments$key = {
  readonly " $data"?: Calendar_enrollments$data;
  readonly " $fragmentSpreads": FragmentRefs<"Calendar_enrollments">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Calendar_enrollments",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "EnrollmentEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Enrollment",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "DateActivityCount",
              "kind": "LinkedField",
              "name": "activityCountByDate",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": [
                    {
                      "kind": "Literal",
                      "name": "raw",
                      "value": true
                    }
                  ],
                  "kind": "ScalarField",
                  "name": "date",
                  "storageKey": "date(raw:true)"
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "count",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "EnrollmentConnection",
  "abstractKey": null
};

(node as any).hash = "829af95bf598096c340e52aa06fbba0f";

export default node;
